module.exports = __webpack_public_path__ + "img/auditStatus-3.13afde66.png";